<template>
	<div class="notification-mobile" :class="{ open: Boolean(route.query.isSearchMenuOpen) && !displayStore.isDesktop }">
		<MobileSubHeader />
		<div class="search_body c_inner mobile">
			<InputSearch
				:model-value="searchValue"
				:placeholder="PLACEHOLDER_SEARCH_TITLE"
				:is-left="true"
				:is-auto-focus="true"
				@update:model-value="onInputSearch"
			/>
			<SearchDropDown
				v-if="searchValue.length !== 0"
				:data="eventSearchData?.search_result ?? []"
				@close="onClickInputItem"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
// core
import { computed, onUnmounted, ref } from 'vue';
import { useRoute } from 'vue-router';
// lib
import { debounce } from 'lodash';

// api
import { useGetEventSearchApi } from '@/api/event';
// component
import SearchDropDown from '@/components/atom/dropdown/SearchDropDown.vue';
import MobileSubHeader from '@/components/layout/header/MobileSubHeader.vue';
// constant
import { PLACEHOLDER_SEARCH_TITLE } from '@/constants/title';
// store
import { useDisplayStore } from '@/stores/display';

// -----variable-----
const displayStore = useDisplayStore();
const route = useRoute();
const searchValue = ref('');

// -----api-----
const { data: eventSearchData } = useGetEventSearchApi(
	computed(() => ({ search: searchValue.value })),
	computed(() => !!searchValue.value)
);

// -----function-----
const onInputSearch = debounce(
	(val: string) => {
		searchValue.value = val;
	},
	200,
	{ leading: false }
);

const onClickInputItem = () => {
	searchValue.value = '';
};

// 화면 나갔을 경우, 스크롤 방지 기능 삭제
onUnmounted(() => {
	document.body.classList.remove('hidden');
});
</script>

<style scoped lang="scss">
// --mobile--

.notification-mobile {
	position: fixed;
	float: right;
	top: 0;
	right: 0;
	width: 100%;
	height: 100dvh;
	background-color: var(--color-bg);
	box-shadow: 0.4rem 0.4rem 1.5rem 0rem #5a5a5a;
	&::-webkit-scrollbar {
		display: none;
	}
	overflow-y: auto;
	color: var(--color-base-white);
	.notification_header-mobile {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: var(--space-xx-small);
		width: 100%;
		height: 6.4rem;
		font-size: var(--font-s-large);
		font-weight: var(--font-w-semi-bold);
		line-height: 2.7rem;
		padding: 1.85rem var(--space-large);
		box-shadow: 4px 4px 10px rgb(0, 0, 0, 0.4);
		.btn_back {
			display: flex;
			gap: 0.4rem;
			img {
				width: 2.6rem;
			}
		}
		.notification_quickMenu-mobile {
			display: flex;
			gap: var(--space-x-small);
			.btn_toggle {
				display: flex;
				gap: 0.05rem;
				img {
					width: 2.4rem;
				}
			}
			.btn_home {
				img {
					width: 2.4rem;
					margin-bottom: 2px;
				}
			}
		}
	}
}
.search_body {
	padding: 1.6rem 2rem;
}
// --list(공통)--
</style>
